export default class Process{
    static async sleep(millis: number): Promise<void>{
        return new Promise(resolve => setTimeout(resolve, millis));
    }
}